var _handle = function(name, args) {
	if (window.console) {
		window.console[name].apply(console, args);
	}
};

var Log = function() {
	var log = function() {
		var args = log.prefix ? [].concat.apply(['(' + log.prefix + ')'], arguments) : arguments;
		_handle('log', args);
	};
	log.prefix = '';
	return log;
};

export default Log;


// WEBPACK FOOTER //
// ./src/lib/Utils/Log.js